// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media all and (min-width: 768px) {
    .home-title {
        width: 100%;
        font-weight: 800;
        font-size: 140px;
        line-height: 90%;
        }

   .find-container {
           display: block;
       }
   .arrow-container .left-arrow, .arrow-container .mid-arrow, .arrow-container .right-arrow{
   opacity: 1;
   }
    .arrow-container .align-items-end {
           margin-left: -10px;
        }
   .about .faceless .title {
       font-weight: 800;
       font-size: 72px;
       line-height: 111%;
       width: 75%;
   }
    .about .about-msg {
          width: 232px;
           font-weight: 500;
           font-size: 20px;
           line-height: 132%;
      }

    .about .hireworkers .title {
       font-weight: 800;
       font-size: 48px;
       line-height: 117%;
    }
    .arrow2-container .right-arrow2 {
      /*  margin-top: 2px */
    }
    .arrow2-container {
        width: 90%;
    }
    .about .recommendation {
       padding: 50px;
    }
    .about .recommendation .desc {
        width: 300px;
       height: 223px;
    }
    .about .recommendation .desc .br{
        height:40px;
    }
    .about .recommendation .form .title{
        font-weight: 600;
        font-size: 24px;
        line-height: 125%;
    }
   .about .recommendation .form .inputs .btn-group input {
          padding-left: 55px;
          font-size: 1.5rem;
          margin: 20px 10px;
      }
   .about .recommendation .form {
     margin: 20px 10px;
     padding: 20px;
   }
   .about .recommendation .form .inputs{
       margin-left: 25px;
   }
   .about .recommendation .form button {
     margin: 20px 10px;
   }
   .about .join .links {
    width: 50%;
   }
   .about .join .form {
    width: 50%;
   }
    .profile .profile-section .header {
        font-size: 28px;
    }
    .job-badge .job-name {
        font-size: 32px;
    }
    .profile-section.subscription img {
        width: 546px;
    }
    .profile .profile-nav .nav-item, .profile .profile-nav .nav-link {
        font-size: 28px;
    }
    .create_recommendation .characteristics .label{
        font-size: 18px;
    }
    .create_recommendation .characteristics .label{
        font-size: 18px;
    }
    .user-badge.big-title .user-name {
        font-size: 48px;
    }
    .recommendation .rating-gauge .label, .recommendation .rating-gauge {
        font-size: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/scss/media_width_768.css"],"names":[],"mappings":"AAAA;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAChB;;GAEL;WACQ,cAAc;OAClB;GACJ;GACA,UAAU;GACV;IACC;WACO,kBAAkB;QACrB;GACL;OACI,gBAAgB;OAChB,eAAe;OACf,iBAAiB;OACjB,UAAU;GACd;IACC;UACM,YAAY;WACX,gBAAgB;WAChB,eAAe;WACf,iBAAiB;MACtB;;IAEF;OACG,gBAAgB;OAChB,eAAe;OACf,iBAAiB;IACpB;IACA;MACE,qBAAqB;IACvB;IACA;QACI,UAAU;IACd;IACA;OACG,aAAa;IAChB;IACA;QACI,YAAY;OACb,aAAa;IAChB;IACA;QACI,WAAW;IACf;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;GACD;UACO,kBAAkB;UAClB,iBAAiB;UACjB,iBAAiB;MACrB;GACH;KACE,iBAAiB;KACjB,aAAa;GACf;GACA;OACI,iBAAiB;GACrB;GACA;KACE,iBAAiB;GACnB;GACA;IACC,UAAU;GACX;GACA;IACC,UAAU;GACX;IACC;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":["@media all and (min-width: 768px) {\n    .home-title {\n        width: 100%;\n        font-weight: 800;\n        font-size: 140px;\n        line-height: 90%;\n        }\n\n   .find-container {\n           display: block;\n       }\n   .arrow-container .left-arrow, .arrow-container .mid-arrow, .arrow-container .right-arrow{\n   opacity: 1;\n   }\n    .arrow-container .align-items-end {\n           margin-left: -10px;\n        }\n   .about .faceless .title {\n       font-weight: 800;\n       font-size: 72px;\n       line-height: 111%;\n       width: 75%;\n   }\n    .about .about-msg {\n          width: 232px;\n           font-weight: 500;\n           font-size: 20px;\n           line-height: 132%;\n      }\n\n    .about .hireworkers .title {\n       font-weight: 800;\n       font-size: 48px;\n       line-height: 117%;\n    }\n    .arrow2-container .right-arrow2 {\n      /*  margin-top: 2px */\n    }\n    .arrow2-container {\n        width: 90%;\n    }\n    .about .recommendation {\n       padding: 50px;\n    }\n    .about .recommendation .desc {\n        width: 300px;\n       height: 223px;\n    }\n    .about .recommendation .desc .br{\n        height:40px;\n    }\n    .about .recommendation .form .title{\n        font-weight: 600;\n        font-size: 24px;\n        line-height: 125%;\n    }\n   .about .recommendation .form .inputs .btn-group input {\n          padding-left: 55px;\n          font-size: 1.5rem;\n          margin: 20px 10px;\n      }\n   .about .recommendation .form {\n     margin: 20px 10px;\n     padding: 20px;\n   }\n   .about .recommendation .form .inputs{\n       margin-left: 25px;\n   }\n   .about .recommendation .form button {\n     margin: 20px 10px;\n   }\n   .about .join .links {\n    width: 50%;\n   }\n   .about .join .form {\n    width: 50%;\n   }\n    .profile .profile-section .header {\n        font-size: 28px;\n    }\n    .job-badge .job-name {\n        font-size: 32px;\n    }\n    .profile-section.subscription img {\n        width: 546px;\n    }\n    .profile .profile-nav .nav-item, .profile .profile-nav .nav-link {\n        font-size: 28px;\n    }\n    .create_recommendation .characteristics .label{\n        font-size: 18px;\n    }\n    .create_recommendation .characteristics .label{\n        font-size: 18px;\n    }\n    .user-badge.big-title .user-name {\n        font-size: 48px;\n    }\n    .recommendation .rating-gauge .label, .recommendation .rating-gauge {\n        font-size: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
